module.exports = __webpack_public_path__ + "img/banner.87c55e10.jpg";